// mutations
const SET_RESSALDOAKHIRSIM = (state, payload) => {
  state.res_saldoakhirsim = payload;
};
const SET_DETAILSINPANAN = (state, payload) => {
  state.detailSimpanan = payload;
};
const SET_RESMUTATIONSIM = (state, payload) => {
  state.res_detailSimpanan = payload;
};
export default {
  SET_RESSALDOAKHIRSIM,
  SET_DETAILSINPANAN,
  SET_RESMUTATIONSIM
};
